import React from "react";
import { View, StyleSheet } from "react-native";
import BaseExtensionController from "./BaseExtensionController";
import NtRootPageContainer from "../../root/components/NtRootPageContainer";
import NtPageSection from "../../components/NtPageSection";
import NtPagination from "../../components/NtPagination";
import NtPageActionButton from "../../components/NtPageActionButton";
import NtListHeader from "../../components/NtListHeader";
import NtListEmpty from "../../components/NtListEmpty";
import NtSearchBar from "../../components/NtSearchBar";
import NtModal from "../../components/NtModal";
import NtDialplanItem from "../components/NtDialplanItem";
import NtDialplanForm from "../components/NtDialplanForm";
import { fetchDialplans } from "../../api/dialplan";
import {
  asyncStorageSetData,
  showToast,
} from "../../common/utils/ControllerUtils";
import Logger from "../../common/utils/Logger";
import settings from "../../config/settings";
import dialplancsvcolumndata from "../data/dialplancsvcolumndata";

class DialplanController extends BaseExtensionController {
  state = {
    ...super.state,
    loading: false,
    data: [],
    totalItems: 0,
    searchText: "",
    page: 1,
  };

  column_location = "@dialplan_column_storage";
  addModalRef = React.createRef();

  componentDidMount() {
    super.componentDidMount?.();
    this.handleDefaultColumnsFetch(
      this.column_location,
      dialplancsvcolumndata.filter((each) => each.default === true),
    );
    this.handleDataFetch();
  }


  handleDataFetch = async () => {
    const domain = this.context?.user?.domain;
    if (!domain) return;
    this.setState({ loading: true });
    const res = await fetchDialplans(
      domain,
      this.state.page,
      settings.pageSizeLoad,
      this.state.searchText,
    );
    Logger("Dialplans fetch", res);
    if (res.ok) {
      this.setState({
        data: res.data?.data || [],
        totalItems: res.data?.total || 0,
      });
    }
    this.setState({ loading: false });
  };

  handleExportFetch = async () => {
    const domain = this.context?.user?.domain;
    const res = await fetchDialplans(domain, 1, 10000000, this.state.searchText);
    return res.ok ? res.data?.data || [] : [];
  };

  handleSearch = (text) => {
    this.setState({ searchText: text, page: 1 }, () => this.handleDataFetch());
  };

  handleExportDataParce = (item, column) => {
    if (column === "dialplan_enabled") return item[column] === false ? "Disabled" : "Enabled";
    return item[column];
  };

  handlePageChange = (nextPage) => {
    this.setState({ page: nextPage }, () => this.handleDataFetch());
  };

  renderAddNewForm = () => (
    <NtModal ref={this.addModalRef}>
      <NtDialplanForm
        onCancel={() => this.addModalRef.current?.dismiss()}
        onSave={() => {
          this.addModalRef.current?.dismiss();
          this.setState({ page: 1 }, () => this.handleDataFetch());
          showToast("Success", "Successfully created the new dialplan");
        }}
      />
    </NtModal>
  );

  renderRow = (item, index) => (
    <NtDialplanItem
      key={item.dialplan_uuid || index}
      item={item}
      columns={this.state.columns}
      onUpdate={() => {
        this.setState({ page: 1 }, () => this.handleDataFetch());
        showToast("Success", "Successfully updated the dialplan");
      }}
      onDelete={() => {
        this.setState({ page: 1 }, () => this.handleDataFetch());
        showToast("Success", "Successfully deleted the dialplan");
      }}
    />
  );

  render() {
    const canEdit = this.handlePermissionCheck(settings.permissionTypeEdit);
    const count = this.state.totalItems || 0;
    const subtitle = `Advanced call-routing rules and XML dialplan entries · ${count} dialplan${count === 1 ? "" : "s"}`;

    const actions = canEdit ? (
      <NtPageActionButton
        icon="plus"
        title="New Dialplan"
        variant="primary"
        onPress={() => this.addModalRef.current?.show()}
      />
    ) : null;

    const searchBar = (
      <NtSearchBar
        value={this.state.searchText}
        onChangeText={this.handleSearch}
      />
    );

    return (
      <NtRootPageContainer
        pageTitle="Dialplans"
        pageSubtitle={subtitle}
        permission={this.handlePermissionCheck()}
        actions={actions}
      >
        <NtPageSection
          search={searchBar}
          footer={
            <NtPagination
              page={this.state.page}
              pageSize={settings.pageSizeLoad}
              total={this.state.totalItems}
              onChange={this.handlePageChange}
            />
          }
        >
          <View style={styles.tableWrap}>
            <NtListHeader
              visible={this.state.data?.length > 0}
              headerContainerStyle={{ marginRight: canEdit ? 35 : 0 }}
              columns={dialplancsvcolumndata}
              selectedColumns={this.state.columns}
              onColumnUpdate={(updated) => {
                asyncStorageSetData(this.column_location, updated);
                this.setState({ columns: updated });
              }}
              exportFileName="dialplans"
              exportDataParser={this.handleExportDataParce}
              exportFetchDataAsync={this.handleExportFetch}
            />
            <NtListEmpty visible={this.state.data?.length === 0} />
            {this.state.data?.map((each, index) => this.renderRow(each, index))}
          </View>
        </NtPageSection>

        {this.renderAddNewForm()}
      </NtRootPageContainer>
    );
  }
}

const styles = StyleSheet.create({
  tableWrap: { paddingHorizontal: 14, paddingVertical: 4 },
});

export default DialplanController;
